






























import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { ProductVariant } from '@/models';

@Component
export default class PrimaryButton extends Vue { }

